// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * PhoneInput — country picker + national number, styled as one control so it
 * reads as a single .rd-input alongside the other fields in a form row.
 * Uses redesign.css tokens only; defines none of its own colours.
 */

.mp-phone {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

/* Focus lives on the wrapper so either half lights the whole control. */
.mp-phone:focus-within {
  border-color: var(--brand-400);
  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.12);
}

.mp-phone.is-error {
  border-color: var(--err);
}

.mp-phone.is-disabled {
  background: var(--bg-inset);
  opacity: 0.7;
}

/* ── Country trigger ─────────────────────────────────────────────────────── */

.mp-phone__country {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 9px 10px 9px 13px;
  border: none;
  border-right: 1px solid var(--line);
  border-radius: var(--r-md) 0 0 var(--r-md);
  background: transparent;
  color: var(--ink);
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}

.mp-phone__country:hover:not(:disabled) {
  background: var(--bg-inset);
}

.mp-phone__country:disabled {
  cursor: not-allowed;
}

/* Windows has no emoji flag font and falls back to the two ISO letters, so the
   glyph is sized to stay legible either way and never carries meaning alone. */
.mp-phone__flag {
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
}

.mp-phone__dial {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.mp-phone__chev {
  color: var(--ink-muted);
  flex-shrink: 0;
}

/* ── National number ─────────────────────────────────────────────────────── */

.mp-phone__number {
  flex: 1 1 auto;
  min-width: 0;
  padding: 9px 13px;
  border: none;
  border-radius: 0 var(--r-md) var(--r-md) 0;
  background: transparent;
  color: var(--ink);
  font-family: inherit;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
  outline: none;
}

.mp-phone__number::placeholder {
  color: var(--t-400);
  letter-spacing: normal;
}

/* ── Popover ─────────────────────────────────────────────────────────────── */

.mp-phone__pop {
  position: absolute;
  z-index: 40;
  top: calc(100% + 6px);
  left: 0;
  width: min(320px, 100%);
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  box-shadow: var(--sh-md, 0 10px 30px rgba(16, 18, 40, 0.14));
  overflow: hidden;
}

.mp-phone__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 11px;
  border-bottom: 1px solid var(--line);
  color: var(--ink-muted);
}

.mp-phone__search input {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  background: transparent;
  color: var(--ink);
  font-family: inherit;
  font-size: 13.5px;
  outline: none;
}

.mp-phone__list {
  margin: 0;
  padding: 4px;
  list-style: none;
  max-height: 264px;
  overflow-y: auto;
}

.mp-phone__opt {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 7px 9px;
  border: none;
  border-radius: var(--r-sm, 8px);
  background: transparent;
  color: var(--ink);
  font-family: inherit;
  font-size: 13.5px;
  text-align: left;
  cursor: pointer;
}

/* One highlight, driven by activeIndex, so mouse and keyboard agree. */
.mp-phone__opt.is-active {
  background: var(--bg-inset);
}

.mp-phone__opt.is-selected {
  font-weight: 600;
}

.mp-phone__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mp-phone__optdial {
  color: var(--ink-muted);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.mp-phone__none {
  padding: 14px 11px;
  color: var(--ink-muted);
  font-size: 13px;
  text-align: center;
}

@media (prefers-reduced-motion: reduce) {
  .mp-phone {
    transition: none;
  }
}

/* Mobile: the popover is allowed the full field width and a shorter list so it
   does not run off the bottom of the viewport. */
@media (max-width: 576px) {
  .mp-phone__pop {
    width: 100%;
  }
  .mp-phone__list {
    max-height: 210px;
  }
  .mp-phone__country,
  .mp-phone__number {
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PhoneInput.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA,wEAAwE;AACxE;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;EACnC,0CAA0C;EAC1C,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;+EAC+E;AAC/E;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;iDACiD;AACjD;EACE;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * PhoneInput — country picker + national number, styled as one control so it\n * reads as a single .rd-input alongside the other fields in a form row.\n * Uses redesign.css tokens only; defines none of its own colours.\n */\n\n.mp-phone {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  transition: border-color 0.16s ease, box-shadow 0.16s ease;\n}\n\n/* Focus lives on the wrapper so either half lights the whole control. */\n.mp-phone:focus-within {\n  border-color: var(--brand-400);\n  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.12);\n}\n\n.mp-phone.is-error {\n  border-color: var(--err);\n}\n\n.mp-phone.is-disabled {\n  background: var(--bg-inset);\n  opacity: 0.7;\n}\n\n/* ── Country trigger ─────────────────────────────────────────────────────── */\n\n.mp-phone__country {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  padding: 9px 10px 9px 13px;\n  border: none;\n  border-right: 1px solid var(--line);\n  border-radius: var(--r-md) 0 0 var(--r-md);\n  background: transparent;\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.mp-phone__country:hover:not(:disabled) {\n  background: var(--bg-inset);\n}\n\n.mp-phone__country:disabled {\n  cursor: not-allowed;\n}\n\n/* Windows has no emoji flag font and falls back to the two ISO letters, so the\n   glyph is sized to stay legible either way and never carries meaning alone. */\n.mp-phone__flag {\n  font-size: 16px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.mp-phone__dial {\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n}\n\n.mp-phone__chev {\n  color: var(--ink-muted);\n  flex-shrink: 0;\n}\n\n/* ── National number ─────────────────────────────────────────────────────── */\n\n.mp-phone__number {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 9px 13px;\n  border: none;\n  border-radius: 0 var(--r-md) var(--r-md) 0;\n  background: transparent;\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 14px;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.01em;\n  outline: none;\n}\n\n.mp-phone__number::placeholder {\n  color: var(--t-400);\n  letter-spacing: normal;\n}\n\n/* ── Popover ─────────────────────────────────────────────────────────────── */\n\n.mp-phone__pop {\n  position: absolute;\n  z-index: 40;\n  top: calc(100% + 6px);\n  left: 0;\n  width: min(320px, 100%);\n  display: flex;\n  flex-direction: column;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  box-shadow: var(--sh-md, 0 10px 30px rgba(16, 18, 40, 0.14));\n  overflow: hidden;\n}\n\n.mp-phone__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 11px;\n  border-bottom: 1px solid var(--line);\n  color: var(--ink-muted);\n}\n\n.mp-phone__search input {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 13.5px;\n  outline: none;\n}\n\n.mp-phone__list {\n  margin: 0;\n  padding: 4px;\n  list-style: none;\n  max-height: 264px;\n  overflow-y: auto;\n}\n\n.mp-phone__opt {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  padding: 7px 9px;\n  border: none;\n  border-radius: var(--r-sm, 8px);\n  background: transparent;\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 13.5px;\n  text-align: left;\n  cursor: pointer;\n}\n\n/* One highlight, driven by activeIndex, so mouse and keyboard agree. */\n.mp-phone__opt.is-active {\n  background: var(--bg-inset);\n}\n\n.mp-phone__opt.is-selected {\n  font-weight: 600;\n}\n\n.mp-phone__name {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mp-phone__optdial {\n  color: var(--ink-muted);\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n\n.mp-phone__none {\n  padding: 14px 11px;\n  color: var(--ink-muted);\n  font-size: 13px;\n  text-align: center;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mp-phone {\n    transition: none;\n  }\n}\n\n/* Mobile: the popover is allowed the full field width and a shorter list so it\n   does not run off the bottom of the viewport. */\n@media (max-width: 576px) {\n  .mp-phone__pop {\n    width: 100%;\n  }\n  .mp-phone__list {\n    max-height: 210px;\n  }\n  .mp-phone__country,\n  .mp-phone__number {\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
